<template>
  <div class="box-body parcelasAdiantamento" v-if="(_.has(propsProposta, 'adiantamento') && propsProposta.adiantamento.length > 0) || (totais.projeto.total !== 0) || (table.items.length > 0)">

    <div v-show="loading" class="overlay" style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; display: block;">
      <i class="fa fa-refresh fa-spin"></i>
    </div>

    <!-- grid -->
    <div v-show="showgrid">
      <div class="row">
        <div class="col-md-12" v-if="formEditavel">
          <button @click="showgrid = !showgrid" type="button" class="btn btn-primary btn-flat"><i class="fa fa-plus-circle" aria-hidden="true"></i> Nova parcela</button>
          <button v-if="table.items.length > 0" @click="distribuirValores" type="button" class="btn btn-back btn-flat"
                  :title="'<h5>Redistribuirá proporcionalmente, o total de R$ <span class=\'realce\'>' + totais.projeto.total + '</span> nas <span class=\'realce\'>' + table.items.length + '</span> parcelas abaixo</h5>'" v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }">
            <i class="fa fa-server" aria-hidden="true"></i> Distribuir</button>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
      <br v-if="formEditavel">
      <div class="row">
        <div class="">
          <div class="table-responsive">
            <b-container fluid>
              <!-- Main table element -->
              <b-table show-empty
                       stacked="md"
                       :bordered="table.bordered"
                       :items="('' + modoVisualizacaoAlteracoes) === 'DETALHADO' ? _.union(table.items, _.filter(propsPropostaBackup.adiantamentos, function(a) { return _.includes(_.get(processoSolicitacao, 'exclusao', []), a.id) }) ) : table.items"
                       :hover="table.hover"
                       :fields="table.fields"
                       :filter="table.filter"
                       :current-page="table.currentPage"
                       :per-page="table.perPage"
                       :sort-by.sync="table.sortBy"
                       :sort-desc.sync="table.sortDesc"
                       :tbody-tr-class="modificacaoLinha"
                       empty-text="Nenhum registro encontrado">

                <template slot="parcela" scope="row">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <div style="width: 30px">
                      <span v-if="('' + modoVisualizacaoAlteracoes) === 'DETALHADO'" class="pull-left">
                        <span v-if="ehItemNovo(row.item)" class="label label-info">Novo</span>
                        <span v-if="ehItemExcluido(row.item)" class="label label-danger">Excluído</span>
                      </span>
                      <span v-else>&nbsp;</span>
                    </div>
                    <div style="width: 30px">{{row.value}}</div>
                    <div style="width: 50px">
                      <span v-if="usuarioLogado.ds_tipo_usuario === 'FUNDACAO' && (formEditavel && !_.has(row.item, 'requisitado'))" class="botoesUpDown">
                        <i class="fa fa-chevron-up" v-if="row.index > 0" @click="moverLinha(row, 'cima')"
                           :title="'<h5>Move essa parcela para Cima<br/>Será a ' + (row.item.parcela - 1) + 'ª parcela</h5>'" v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"></i>
                        <i class="fa fa-chevron-down" v-if="row.index < table.items.length - 1" @click="moverLinha(row, 'baixo')"
                           :title="'<h5>Move essa parcela para Baixo<br/>Será a ' + (row.item.parcela + 1) + 'ª parcela</h5>'" v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"></i>
                      </span>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>
                </template>

                <template slot="origem" scope="row">
                  <div class="input-group" style="display: inline-table;">
                    <span>{{ rotuloOrigemParcela(row.value) }}</span>
                    <span v-if="('' + modoVisualizacaoAlteracoes) === 'DETALHADO' && _.get(_.find(_.get(processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'origem.0')" class="input-group-addon valorAlterado">
                      {{ rotuloOrigemParcela('' + _.get(_.find(_.get(processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'origem.0', '')) }}
                    </span>
                  </div>
                </template>

                <template slot="valor_fbb" scope="row">
                  <div class="input-group" style="display: inline-table;">
                    <span v-if="row.item.valor_fbb !== null && row.item.valor_fbb !== undefined">
                      {{ row.item.valor_fbb | real }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </template>

                <template slot="valor_parc" scope="row">
                  <div class="input-group" style="display: inline-table;">
                    <span v-if="row.item.valor_parc !== null && row.item.valor_parc !== undefined">
                      {{ row.item.valor_parc | real }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </template>

                <template slot="valor" scope="row">
                  <div class="input-group" style="display: inline-table;">
                    <span>{{row.value | real}}</span>
                    <span class="input-group-addon valorAlterado" v-if="('' + modoVisualizacaoAlteracoes) === 'DETALHADO' && _.find(_.get(processoSolicitacao, 'alteracao', []), ['id', row.item.id])">
                      {{ _.get(_.find(_.get(processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'valor.0', '0') | real}}
                    </span>
                  </div>
                </template>

                <template slot="requisitado" scope="row">
                  <span :title="'<h5>Valor liberado ou em análise para liberação</h5>'" v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }">
                    {{row.value | real}}
                  </span>
                </template>

                <template slot="percentual_comprovado" scope="row">
                  <span :title="'<h5>Refere-se a todas as prestações de contas registradas no SGP sobre o valor requisitado</h5>'" v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                        v-if="row.value > 0"
                        :class="(row.value >= 1 ? 'atingido100' : (row.value >= 0.8 ? 'atingido80' : 'nao_atingido'))">
                    {{row.value | percentage}}
                  </span>
                </template>


                <template slot="actions" scope="row">
                  <div v-if="propsLayout != 'EXECUCAO' || (formEditavel && !_.has(row.item, 'requisitado')) || (formEditavel && ehParcelaSemOrigem(row.item))">
                    <span v-if="ehItemExcluido(row.item)">
                      <b-button type="button" @click.stop="reincluir(row)" class="btn btn-back btn-flat btn-sm"><i class="fa fa-refresh" aria-hidden="true"></i> Reincluir</b-button>
                    </span>
                    <span v-else>
                      <b-button type="button" :disabled="false" @click.stop="edita(row)" class="btn btn-primary btn-sm btn-flat"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Editar</b-button>
                      <b-button type="button" :disabled="false" class="btn btn-danger btn-sm btn-flat" v-confirm="{ok: retorno => exclui(row), cancel: doNothing, message: 'Deseja <b>APAGAR</b> a parcela número ' + row.item.parcela + ' ?'}">
                        <i class="fa fa-trash" aria-hidden="true"></i> Excluir
                      </b-button>
                    </span>
                  </div>
                </template>
              </b-table>

              <b-row v-if="table.items.length > table.perPage">
                <b-col md="12" class="my-1" right>
                  <b-pagination :total-rows="table.totalRows" :per-page="table.perPage" v-model="table.currentPage" class="" />
                </b-col>
              </b-row>

            </b-container>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table class="totais">
            <colgroup>
              <col class="col-parcela">
              <col class="col-origem">
              <col class="col-fase1">
              <col class="col-fase5">
              <col class="col-valor-adiantavel">
              <col class="col-valor-requisitado">
              <col class="col-percentual">
              <col class="col-acoes">
            </colgroup>

            <tr>
              <td></td>
              <td></td>

              <td class="centralizado">
                <span v-if="totais.projeto.fbb !== 0">Total Fundação</span>
              </td>

              <td class="centralizado">
                <span v-if="totais.projeto.parceiros !== 0">Total Parceiro Estratégico</span>
              </td>

              <td class="centralizado">
                <span>Total do Projeto</span>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td></td>

              <td class="centralizado valor">
                <span
                  v-if="totais.projeto.fbb !== 0"
                  :title="'<h5>Soma de todas as parcelas da coluna Fundação BB (Fase 1)</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ totais.distribuidos.fbb | real }}
                </span>
              </td>

              <td class="centralizado valor">
                <span
                  v-if="totais.projeto.parceiros !== 0"
                  :title="'<h5>Soma de todas as parcelas da coluna Parceiro Estratégico (Fase 5)</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ totais.distribuidos.parceiros | real }}
                </span>
              </td>

              <td class="centralizado valor">
                <span
                  v-if="normalizarMoeda(totais.projeto.total - totais.distribuidos.total) >= 0"
                  :title="'<h5>Soma de todas as parcelas da coluna Valor Adiantável</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ totais.distribuidos.total | real }}
                </span>

                <span
                  v-else
                  class="atencao"
                  :title="'<h5>O valor total distribuído ultrapassou o total adiantável no cronograma do projeto</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ totais.distribuidos.total | real }}
                </span>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr
              v-if="usuarioLogado.ds_tipo_usuario === 'FUNDACAO'"
            >
              <td></td>
              <td></td>

              <td class="centralizado valor">
                <span
                  class="atencao"
                  v-bind:style="(totais.saldoDisponivel.fbb >= -0.01 ? 'background: steelblue !important;' : '')"
                  :title="'<h5>' + (totais.saldoDisponivel.fbb >= -0.01 ? 'Saldo disponível para novas parcelas' : 'Ultrapassou o limite de valores da Fundação para distribuir em parcelas') + '</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ (Math.abs(totais.saldoDisponivel.fbb) < 0.01 ? 0 : totais.saldoDisponivel.fbb) | real }}
                </span>
              </td>

              <td class="centralizado valor">
                <span
                  class="atencao"
                  v-bind:style="(totais.saldoDisponivel.parceiros >= -0.01 ? 'background: steelblue !important;' : '')"
                  :title="'<h5>' + (totais.saldoDisponivel.parceiros >= -0.01 ? 'Saldo disponível para novas parcelas' : 'Ultrapassou o limite de valores de Parceiro Estratégico para distribuir em parcelas') + '</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ (Math.abs(totais.saldoDisponivel.parceiros) < 0.01 ? 0 : totais.saldoDisponivel.parceiros) | real }}
                </span>
              </td>

              <td class="centralizado valor">
                <span
                  class="atencao"
                  v-bind:style="(totais.saldoDisponivel.total >= -0.01 ? 'background: steelblue !important;' : '')"
                  :title="'<h5>' + (totais.saldoDisponivel.total >= -0.01 ? 'Saldo disponível para novas parcelas' : 'Ultrapassou o limite de valores do projeto para distribuir em parcelas') + '</h5>'"
                  v-tippy="{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
                >
                  {{ (Math.abs(totais.saldoDisponivel.total) < 0.01 ? 0 : totais.saldoDisponivel.total) | real }}
                </span>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>

    </div>

    <!--Form-->
    <div v-if="!showgrid" class="row well well-sm no-shadow">
      <div class="col-md-12">

        <!-- Parcela -->
        <div class="form-group" v-show="_.has(parcela, 'parcela')">
          <label class="control-label col-md-2">Parcela:</label>
          <div class="col-md-2">
            <div>
              <label class="control-label">{{parcela.parcela}}</label>
            </div>
          </div>
        </div>
        <!-- Origem do recurso -->
        <div class="form-group required-field" :class="{ 'has-error' : errors.first('origem')}">
          <label for="origem" class="control-label col-md-2">Origem:</label>
          <div class="col-md-2">
            <div>
              <select v-model="parcela.origem" @click="verificaFase" :disabled="existeFaseFBB === 0 && existeFaseParc === 0" name="origem" id="origem" class="form-control" v-validate="'required'">
                <option :value='1' v-if="existeFaseFBB > 0">Fundação</option>
                <option :value='5' v-if="existeFaseParc > 0">Parceiro Estratégico</option>
                <option :value='0' v-if="existeFaseParc > 0 && existeFaseFBB > 0">Parcela Mista</option>
              </select>
            </div>
            <span v-if="errors.first('origem')" class="label label-danger"> {{ errors.first('origem') }}</span>
          </div>
          <div class="col-md-8" v-show="existeFaseFBB === 0 && existeFaseParc === 0"><span class="atencao">Precisa ter algum item marcado como Adiantavel no cronograma</span></div>
        </div>

        <!-- Valor parcela (origem 1 ou 5) -->
        <!-- key obrigatoria nos campos de valor: sem ela o Vue reaproveita o <money> do campo
             unico como campo do branch misto e o vee-validate mantem name/getter antigos,
             validando a soma das origens contra o limite de uma origem so (falha silenciosa) -->
        <div v-if="('' + parcela.origem) !== '0'" key="campo-valor-unico" class="form-group required-field" :class="{ 'has-error' : errors.first('valor')}">
          <label class="control-label col-md-2">Valor:</label>
          <div class="col-md-2">
            <div class="input-group">
              <div>
                <money v-model="parcela.valor" key="money-valor-unico" name="valor" class="form-control text-right" type="text" v-validate="'required|min_value:1|max_value:' + Math.max(0, limiteParcela(parcela)).toFixed(2)"></money>
              </div>
            </div>
            <span v-if="errors.first('valor')" class="label label-danger"> {{ errors.first('valor') }}</span>
          </div>
          <div class="col-md-4">Valor máximo permitido para esta parcela: <strong>{{Math.max(0, limiteParcela(parcela)) | real}}</strong></div>
        </div>

        <!-- Valor parcela Misto (origem 0): valor_fbb + valor_parc -->
        <template v-else>
          <div key="campo-valor-fbb" class="form-group required-field" :class="{ 'has-error' : errors.first('valor_fbb')}">
            <label class="control-label col-md-2">Valor Fundação BB:</label>
            <div class="col-md-2">
              <div class="input-group">
                <div>
                  <money v-model="parcela.valor_fbb" key="money-valor-fbb" name="valor_fbb" class="form-control text-right" type="text" v-validate="'required|min_value:0|max_value:' + Math.max(0, limiteParcelaFundacao(parcela)).toFixed(2)"></money>
                </div>
              </div>
              <span v-if="errors.first('valor_fbb')" class="label label-danger"> {{ errors.first('valor_fbb') }}</span>
            </div>
            <div class="col-md-4">Limite Fundação: <strong>{{Math.max(0, limiteParcelaFundacao(parcela)) | real}}</strong></div>
          </div>
          <div key="campo-valor-parc" class="form-group required-field" :class="{ 'has-error' : errors.first('valor_parc')}">
            <label class="control-label col-md-2">Valor Parceiro Estratégico:</label>
            <div class="col-md-2">
              <div class="input-group">
                <div>
                  <money v-model="parcela.valor_parc" key="money-valor-parc" name="valor_parc" class="form-control text-right" type="text" v-validate="'required|min_value:0|max_value:' + Math.max(0, limiteParcelaParceiro(parcela)).toFixed(2)"></money>
                </div>
              </div>
              <span v-if="errors.first('valor_parc')" class="label label-danger"> {{ errors.first('valor_parc') }}</span>
            </div>
            <div class="col-md-4">Limite Parceiro: <strong>{{Math.max(0, limiteParcelaParceiro(parcela)) | real}}</strong></div>
          </div>
          <div class="form-group">
            <label class="control-label col-md-2">Total da parcela:</label>
            <div class="col-md-6">
              <strong>{{ ((+parcela.valor_fbb || 0) + (+parcela.valor_parc || 0)) | real }}</strong>
            </div>
          </div>
        </template>

        <!-- Botões -->
        <div class="form-group">
          <div class="col-md-4 col-md-offset-2">
            <button @click="onAdd" type="button" class="btn btn-confirm btn-flat"><i class="fa fa-check" aria-hidden="true"></i> Ok</button>
            <button @click="onCancel" type="button" class="btn btn-back btn-flat"><i class="fa fa-times-circle" aria-hidden="true"></i> Cancelar</button>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div v-else class="box-header">
    Não há itens adiantáveis nem parcelas cadastradas
  </div>

</template>

<script>
  /* eslint-disable eqeqeq */
  import { mapGetters } from 'vuex'

  export default {
    name: 'parcela-adiantamento',
    data () {
      return {
        loading: false,
        showgrid: true,
        parcelaAdiantameto: [],
        totais: {
          projeto: {
            fbb: 0,
            parceiros: 0,
            misto: 0,
            total: 0
          },
          distribuidos: {
            fbb: 0,
            parceiros: 0,
            misto: 0,
            total: 0
          },
          // Total dos itens editáveis (sem `requisitado`): base para `restantes`/limites.
          // Mantemos `distribuidos.*` como total histórico exibido.
          distribuidosEditaveis: {
            fbb: 0,
            parceiros: 0,
            misto: 0,
            total: 0
          },
          // Saldo REAL disponivel para NOVA parcela:
          //   projeto - TODAS parcelas ja lancadas (inclui requisitadas/comprovadas).
          //   Base de limiteParcelaFundacao/Parceiro e max_value dos inputs.
          //   Diferente de `restantes` (que e saldo EDITAVEL para reorganizar parcelas novas).
          saldoDisponivel: {
            fbb: 0,
            parceiros: 0,
            misto: 0,
            total: 0
          },
          restantes: {
            fbb: 0,
            parceiros: 0,
            misto: 0,
            total: 0
          },
          residuo: {
            fbb: 0,
            parceiros: 0,
            misto: 0,
            total: 0
          }
        },
        existeFaseFBB: 0,
        existeFaseParc: 0,
        table: {
          items: this.propsParcelas,
          filter: null,
          hover: true,
          bordered: true,
          existe: false,
          currentPage: 1,
          totalRows: 0,
          sortBy: 'parcela',
          sortDesc: false,
          perPage: 100,
          fields: [
            { key: 'parcela', label: 'Parcela', sortable: false, thStyle: 'text-align: center; width: 5%', class: 'text-center' },
            { key: 'origem', label: 'Origem', sortable: false, thStyle: 'text-align: center;width: 15%', class: 'text-center' },
            { key: 'valor_fbb', label: 'Fundação BB (Fase 1)', sortable: false, thStyle: 'text-align: center;width: 14%', class: 'text-center' },
            { key: 'valor_parc', label: 'Parceiro Estratégico (Fase 5)', sortable: false, thStyle: 'text-align: center;width: 17%', class: 'text-center' },
            { key: 'valor', label: 'Valor Adiantável', sortable: false, thStyle: 'text-align: center;width: 17%', class: 'text-center' },
            { key: 'requisitado', label: 'Valor Requisitado', sortable: false, thStyle: 'text-align: center;width: 14%', class: 'text-center' },
            { key: 'percentual_comprovado', label: '% Comprov.', sortable: false, thStyle: 'text-align: center;width: 8%', class: 'text-center' },
            { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 20%', class: 'text-center' }
          ]
        },
        parcela: {},
        parcelaTabela: {},
        adiantamentosConcedidos: [],
        percentualMaximoSobreResiduos: 0.25,
        editandoIndex: null,
        formEditavel: false,
        // guard anti-loop: quando true, watcher de table.items não emite parcelaAdicionada
        suprimirEmissao: false
      }
    },
    props: ['propsParcelas', 'editavel', 'propsAtividades', 'propsProposta', 'propsLayout', 'propsPropostaBackup',
      'modoVisualizacaoAlteracoes', // opcional - exibe as alterações realizadas. Se o valor for RESUMIDO mostra só o total de modificações, se DETALHADO mostrará quais alterações houveram. Sem valor, null ou outra opção, não mostrará as modificações
      'atualizar', // opcional - valor qualquer somente para disparar atualização
      'processoSolicitacao', // opcional - recebe o objeto da solicitação de alteração
      'alteracaoProjeto' // opcional - verifica se é alteracao de projeto
    ],
    watch: {
      atualizar: function () {
        this.calcularTotais()
      },
      propsParcelas: function () {
        // ativa guard para evitar re-emit em loop com o pai
        this.suprimirEmissao = true
        let parc = _.filter(this.propsParcelas, function (value) {
          return value !== null
        })
        this.table.items = _.cloneDeep(this.consolidarParcelasAdiantamento(parc))
        this.table.totalRows = this.table.items.length
        // Re-aplica requisitado/percentual_comprovado em table.items após reescrita,
        // caso o cache de adiantamentosConcedidos já tenha sido populado.
        this.aplicarAdiantamentosConcedidosEmTableItems()
        // Se EXECUCAO e cache ainda vazio (created disparou com propsParcelas vazio),
        // refaz a busca agora que table.items tem dados. calcularTotais será chamado no .then.
        if (this.propsLayout == 'EXECUCAO' && (!this.adiantamentosConcedidos || !this.adiantamentosConcedidos.length)) {
          this.buscaAdiantamentosConcedidos()
          this.$nextTick(() => { this.suprimirEmissao = false })
          return
        }
        this.calcularTotais()
        this.$nextTick(() => { this.suprimirEmissao = false })
      },
      editavel: function () {
        this.formEditavel = this.editavel
      },
      'table.items' () {
        if (this.suprimirEmissao) return
        // emite no formato canônico expandido (origem 0 -> duas linhas origem 1 + origem 5)
        this.$emit('parcelaAdicionada', this.expandirParcelasAdiantamento(this.table.items))
      },
      'parcela.valor_fbb' () {
        if (('' + this.parcela.origem) === '0') {
          this.parcela.valor = (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0)
        }
      },
      'parcela.valor_parc' () {
        if (('' + this.parcela.origem) === '0') {
          this.parcela.valor = (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0)
        }
      },
      showgrid: function () {
        if (this.existeFaseFBB > 0 && this.existeFaseParc === 0) {
          this.parcela.origem = 1
        } else if (this.existeFaseFBB === 0 && this.existeFaseParc > 0) {
          this.parcela.origem = 5
        }
        this.$emit('validacaoParcelasAdiantamento', {'tag': 'parcelasEditando', 'ativo': (!this.showgrid), 'tipo': 'restricao', 'acao': null, 'mensagem': '<span class=\'restricaoEditandoInformacao\'>Parcela de Adiantamento em edição<span>'})
      }
    },
    computed: {
      ...mapGetters([
        'usuarioLogado'
      ])
    },
    mounted () {
      let bc = new BroadcastChannel('propostas')
      let vm = this
      bc.onmessage = function (e) {
        let mensagem = e.data
        if (('' + mensagem.id) === ('' + vm.$route.params.id)) {
          if (mensagem.acao === 'notificacaoAtualizacaoCronograma') {
            vm.calcularTotais()
          } else {
          }
        }
      }
      this.calcularTotais()
    },
    created: function () {
      let parc = _.filter(this.propsParcelas, function (value) {
        return value !== null
      })
      this.table.items = _.cloneDeep(this.consolidarParcelasAdiantamento(parc))
      if (this.propsLayout != 'EXECUCAO') {
        this.table.fields = _.filter(this.table.fields, f => f.key !== 'requisitado' && f.key !== 'percentual_comprovado')
      }
      // this.calcularTotais()
      if (this.propsLayout == 'EXECUCAO') {
        this.buscaAdiantamentosConcedidos()
      }
      this.formEditavel = this.editavel
    },
    methods: {
      toNumberSafe (valor) {
        if (_.isNil(valor) || valor === '') return 0
        if (_.isNumber(valor)) return valor
        if (_.isString(valor)) {
          return _.toNumber(valor.replace(/\./g, '').replace(',', '.'))
        }
        return _.toNumber(valor) || 0
      },
      somarCampoParcelas (campo) {
        // Soma parcela por parcela em CENTAVOS INTEIROS para eliminar float drift.
        //   Antes: 53666.67 * 4 + 53666.25 + 306666.67 = 574999.5999999999 em float.
        //   Agora: somatorio em centavos -> 57499959 / 100 = 574999.59 exato.
        const centavos = (this.table.items || []).reduce((total, parc) => {
          return total + this.toCentavos(this.toNumberSafe(_.get(parc, campo, 0)))
        }, 0)
        return this.fromCentavos(centavos)
      },
      obterValorFundacaoParcela (parc) {
        const origem = '' + parc.origem
        // Parcela exclusiva Fundação
        if (origem === '1') {
          return this.toNumberSafe(parc.valor)
        }
        // Parcela Mista: usar a coluna Fundação da própria linha
        if (origem === '0') {
          return this.toNumberSafe(
            _.get(parc, 'valor_fundacao',
              _.get(parc, 'valorFundacao',
                _.get(parc, 'fase1',
                  _.get(parc, 'valor_fase_1', 0)
                )
              )
            )
          )
        }
        return 0
      },
      obterValorParceiroParcela (parc) {
        const origem = '' + parc.origem
        // Parcela exclusiva Parceiro
        if (origem === '5') {
          return this.toNumberSafe(parc.valor)
        }
        // Parcela Mista: usar a coluna Parceiro da própria linha
        if (origem === '0') {
          return this.toNumberSafe(
            _.get(parc, 'valor_parceiro',
              _.get(parc, 'valorParceiro',
                _.get(parc, 'fase5',
                  _.get(parc, 'valor_fase_5', 0)
                )
              )
            )
          )
        }
        return 0
      },
      valorProjetoOrigem (fase, texto) {
        let vm = this
        let valorTotal = _.sumBy(vm.propsAtividades, function (atv) {
          let valorOrc = (_.has(atv, 'itens_orcamentos') && atv.itens_orcamentos.length > 0)
            ? _.sumBy(atv.itens_orcamentos, function (item) {
              let itemDesp = (
                _.has(item, 'origem') &&
                (
                  ('' + item.origem) === '' + fase ||
                  item.origem === texto
                ) &&
                (
                  ('' + item.adiantavel === '1') ||
                  item.adiantavel === true
                )
              )
                ? (
                    _.has(item, 'valorOrcado')
                      ? vm.truncarValor(
                          (item.valorOrcado > 0)
                            ? item.valorOrcado + (!_.includes(item.id, 'novo') ? (_.toNumber(_.get(item, 'valorAlteracao', 0))) : 0)
                            : item.valorOrcado + (_.toNumber(_.get(item, 'valorAlteracao', 0)))
                        )
                      : (
                          _.has(item, 'valor_unitario') &&
                          _.has(item, 'quantidade') &&
                          !_.isNil(item.valor_unitario)
                        )
                        ? vm.truncarValor(parseFloat(item.valor_unitario) * parseFloat(item.quantidade))
                        : _.sumBy(item.orcamentos_mensalizados, function (mes) {
                          return _.has(mes, 'valor') ? vm.truncarValor(mes.valor) : 0
                        }) + (_.toNumber(_.get(item, 'valorAlteracao', 0)))
                  )
                : 0
              return itemDesp
            })
            : 0
          return valorOrc
        })
        return this.truncarRound(valorTotal)
      },
      calcularTotais () {
        console.log('ANTES calcularTotais table.items', JSON.parse(JSON.stringify(this.table.items)))
        this.totais.distribuidos.total = 0
        this.totais.distribuidos.fbb = 0
        this.totais.distribuidos.parceiros = 0
        this.totais.distribuidos.misto = 0
        this.totais.projeto.total = 0
        this.totais.projeto.fbb = 0
        this.totais.projeto.parceiros = 0
        this.totais.projeto.misto = 0
        // Totais do projeto/orçamento
        this.totais.projeto.fbb = this.truncarValor(this.valorProjetoOrigem('1', 'FUNDACAO'))
        this.totais.projeto.parceiros = this.truncarValor(this.valorProjetoOrigem('5', 'PARCEIRO_ESTRATEGICO'))
        this.totais.projeto.misto = 0
        this.totais.projeto.total = this.truncarValor(
          this.totais.projeto.fbb + this.totais.projeto.parceiros
        )
        // Totais exibidos no rodapé = refletem as colunas da grade
        this.totais.distribuidos.fbb = this.somarCampoParcelas('valor_fbb')
        this.totais.distribuidos.parceiros = this.somarCampoParcelas('valor_parc')
        this.totais.distribuidos.misto = 0
        this.totais.distribuidos.total = this.somarCampoParcelas('valor')
        // Total editável: exclui parcelas já requisitadas/comprovadas (histórico intocável).
        // Usado para calcular restantes/limites das parcelas novas.
        const editaveis = (this.table.items || []).filter(p => !_.has(p, 'requisitado'))
        const somarEditaveis = (campo) => this.truncarValor(
          editaveis.reduce((t, p) => t + this.toNumberSafe(_.get(p, campo, 0)), 0)
        )
        this.totais.distribuidosEditaveis.fbb = somarEditaveis('valor_fbb')
        this.totais.distribuidosEditaveis.parceiros = somarEditaveis('valor_parc')
        this.totais.distribuidosEditaveis.misto = 0
        this.totais.distribuidosEditaveis.total = somarEditaveis('valor')
        // Saldo disponivel para NOVA parcela: usa `distribuidos` (todas as parcelas,
        //   incluindo requisitadas/comprovadas). Base de max_value dos inputs.
        //   Subtracao em centavos inteiros + normalizarSaldoDisponivel para tratar:
        //     - residuo de 1 centavo (totalmente parcelado) -> 0
        //     - X.999,99 (divida historica + suplementacao) -> X+1.000,00
        this.totais.saldoDisponivel.fbb = this.normalizarSaldoDisponivel(
          this.fromCentavos(this.toCentavos(this.totais.projeto.fbb) - this.toCentavos(this.totais.distribuidos.fbb))
        )
        this.totais.saldoDisponivel.parceiros = this.normalizarSaldoDisponivel(
          this.fromCentavos(this.toCentavos(this.totais.projeto.parceiros) - this.toCentavos(this.totais.distribuidos.parceiros))
        )
        this.totais.saldoDisponivel.misto = 0
        this.totais.saldoDisponivel.total = this.normalizarSaldoDisponivel(
          this.fromCentavos(this.toCentavos(this.totais.projeto.total) - this.toCentavos(this.totais.distribuidos.total))
        )
        // Restantes (base: distribuidosEditaveis — parcelas comprovadas são intocáveis)
        this.totais.restantes.fbb = this.truncarValor(
          this.totais.projeto.fbb - this.totais.distribuidosEditaveis.fbb
        )
        this.totais.restantes.parceiros = this.truncarValor(
          this.totais.projeto.parceiros - this.totais.distribuidosEditaveis.parceiros
        )
        // compatibilidade: soma dos restantes individuais (não há mais hardcode = 0).
        // Os inputs Misto usam limiteParcelaFundacao / limiteParcelaParceiro separadamente.
        this.totais.restantes.misto = this.truncarValor(
          this.totais.restantes.fbb + this.totais.restantes.parceiros
        )
        this.totais.restantes.total = this.truncarValor(
          this.totais.projeto.total - this.totais.distribuidosEditaveis.total
        )
        // Resíduos
        if (this.totais.residuo.total === 0) {
          this.totais.residuo.fbb = this.truncarValor(
            _.sumBy(this.table.items, function (p) {
              return (p.valor - p.requisitado) > 0 && ('' + p.origem) === '1'
                ? (p.valor - p.requisitado)
                : 0
            }) * this.percentualMaximoSobreResiduos
          )
          this.totais.residuo.parceiros = this.truncarValor(
            _.sumBy(this.table.items, function (p) {
              return (p.valor - p.requisitado) > 0 && ('' + p.origem) === '5'
                ? (p.valor - p.requisitado)
                : 0
            }) * this.percentualMaximoSobreResiduos
          )
          this.totais.residuo.misto = 0
          this.totais.residuo.total = this.truncarValor(
            this.totais.residuo.fbb + this.totais.residuo.parceiros
          )
        }
        this.numerarParcelas()
        this.verificaFase()
        // Ajuste de arredondamento final
        let totalProjeto = this.totais.projeto.total
        let totalDistribuido = this.totais.distribuidos.total
        if (totalProjeto !== totalDistribuido) {
          let totalProjetoFloor = this.truncarValor2(this.totais.projeto.total)
          let totalDistribuidoFloor = this.truncarValor2(this.totais.distribuidos.total)
          if (totalProjetoFloor !== totalDistribuidoFloor) {
            this.totais.projeto.total = this.truncarCeil(this.totais.projeto.total)
            this.totais.distribuidos.total = this.truncarCeil(this.totais.distribuidos.total)
          } else {
            this.totais.projeto.total = this.truncarValor2(this.totais.projeto.total)
            this.totais.distribuidos.total = this.truncarValor2(this.totais.distribuidos.total)
          }
        }
        // Se quiser manter o destaque visual coerente também nas colunas individuais
        if (this.totais.projeto.fbb !== this.totais.distribuidos.fbb) {
          let projFbbFloor = this.truncarValor2(this.totais.projeto.fbb)
          let distFbbFloor = this.truncarValor2(this.totais.distribuidos.fbb)
          if (projFbbFloor !== distFbbFloor) {
            this.totais.projeto.fbb = this.truncarCeil(this.totais.projeto.fbb)
            this.totais.distribuidos.fbb = this.truncarCeil(this.totais.distribuidos.fbb)
          } else {
            this.totais.projeto.fbb = this.truncarValor2(this.totais.projeto.fbb)
            this.totais.distribuidos.fbb = this.truncarValor2(this.totais.distribuidos.fbb)
          }
        }
        if (this.totais.projeto.parceiros !== this.totais.distribuidos.parceiros) {
          let projParcFloor = this.truncarValor2(this.totais.projeto.parceiros)
          let distParcFloor = this.truncarValor2(this.totais.distribuidos.parceiros)
          if (projParcFloor !== distParcFloor) {
            this.totais.projeto.parceiros = this.truncarCeil(this.totais.projeto.parceiros)
            this.totais.distribuidos.parceiros = this.truncarCeil(this.totais.distribuidos.parceiros)
          } else {
            this.totais.projeto.parceiros = this.truncarValor2(this.totais.projeto.parceiros)
            this.totais.distribuidos.parceiros = this.truncarValor2(this.totais.distribuidos.parceiros)
          }
        }
        console.log('DEPOIS totais.distribuidos', JSON.parse(JSON.stringify(this.totais.distribuidos)))
        // Mantido o emit existente
        this.$emit('validacaoParcelasAdiantamento', {
          tag: 'parcelasAdiantamentoZeradas',
          ativo: (this.table.items.length > 0 && _.filter(this.table.items, ['valor', 0]).length > 0),
          tipo: 'restricao',
          acao: null,
          mensagem: 'Há <b>' + _.filter(this.table.items, ['valor', 0]).length + '</b> Parcela(s) de Adiantamento com valor <b>R$ 0,00</b> (zerada). Deve preencher ou eliminar.'
        })
        // Parcelas mistas legadas sem valores por origem distorcem o saldo por origem:
        // pede correcao manual (editar a parcela e informar Fundacao/Parceiro)
        const legadas = _.filter(this.table.items, ['_legadoSemBreakdown', true])
        this.$emit('validacaoParcelasAdiantamento', {
          tag: 'parcelasAdiantamentoSemBreakdown',
          ativo: legadas.length > 0,
          tipo: 'restricao',
          acao: null,
          mensagem: 'Há <b>' + legadas.length + '</b> Parcela(s) de Adiantamento Mista(s) sem os valores por origem (Fundação/Parceiro). Edite a(s) parcela(s) e informe os valores.'
        })
      },
      truncarValor (valor) {
        // return Math.ceil(valor * 100) / 100
        return valor
      },
      truncarValor2 (valor) {
        return Math.floor(valor * 100) / 100
        // return valor
      },
      truncarCeil (valor) {
        return Math.ceil(valor * 100) / 100
      },
      truncarRound (valor) {
        return Math.round(valor * 100) / 100
      },
      // Helpers monetarios em centavos inteiros: elimina drift de float em somas.
      //   Uso restrito a somarCampoParcelas e saldoDisponivel.
      //   NAO substitui truncarValor global nem altera valorProjetoOrigem.
      toCentavos (valor) {
        return Math.round((Number(valor) || 0) * 100)
      },
      fromCentavos (centavos) {
        return centavos / 100
      },
      // Normaliza residuo de centavo: se |valor| <= 1 centavo, retorna 0.
      //   Cobre casos onde projeto.fbb (com truncarRound de outra fonte) gera diferenca
      //   minima contra distribuidos.fbb por arredondamento upstream. Sem mascarar
      //   ultrapassagens reais (> 1 centavo) que devem continuar visiveis.
      normalizarMoeda (valor) {
        const c = this.toCentavos(valor)
        return Math.abs(c) <= 1 ? 0 : c / 100
      },
      // Normaliza SOMENTE o saldo disponivel para nova parcela.
      // Tratamento de DIVIDA HISTORICA de centavo em parcelas antigas:
      //   Projetos antigos podem ter soma de parcelas excedendo em R$ 0,01 o total
      //   adiantavel original (resultado de arredondamentos legados, possivelmente
      //   Math.ceil em cronogramas anteriores). Esse 1 centavo permaneceu nos dados
      //   historicos e nao deve travar operacoes posteriores como suplementacao.
      //
      // Regras (escopo restrito a saldoDisponivel; NAO aplicar globalmente):
      //   1) Residual |x| <= 1 centavo: tratar como 0 (cobre o caso totalmente parcelado).
      //   2) Saldo positivo terminando em 99 centavos: arredondar +1 centavo.
      //      Heuristica: divergencia de +R$ 0,01 nas parcelas faz suplementacao inteira
      //      aparecer como X.999,99 (ex: +R$ 10.000 vira saldo R$ 9.999,99).
      //
      // RISCO ASSUMIDO: saldo LEGITIMO de R$ X.999,99 (sem divida historica) seria
      //   arredondado em +1 centavo. Saldos terminando em 99 sao raros sem divergencia;
      //   caso patologico nao foi observado. Se aparecer, a forma mais robusta seria
      //   condicionar a regra (2) a presenca de divergencia detectavel
      //   (somaValorOrcadoSemAlteracao < distribuidos por origem). Nao aplicado nesta
      //   rodada para manter MIN DIFF; expandir se necessario.
      normalizarSaldoDisponivel (valor) {
        const centavos = this.toCentavos(valor)
        // Regra 1: residual de centavo
        if (Math.abs(centavos) <= 1) {
          return 0
        }
        // Regra 2: divida historica de +1 centavo -> suplementacao aparece como X.999,99
        //   centavos > 0 protege contra negativos. Math.abs(% 100) defensivo
        //   (em JS, (-99) % 100 === -99; o guard positivo cobre, mas Math.abs eh seguro).
        if (centavos > 0 && Math.abs(centavos % 100) === 99) {
          return (centavos + 1) / 100
        }
        return centavos / 100
      },
      numerarParcelas () {
        for (let i = 0; i < this.table.items.length; i++) {
          _.set(this.table.items[i], 'parcela', i + 1)
        }
        this.$forceUpdate()
      },
      distribuirValores () {
        let vm = this
        let fases = ['1', '5']
        fases.forEach((fase) => {
          let quantidade = _.filter(this.table.items, function (i) { return ('' + i.origem) === fase && !_.has(i, 'requisitado') }).length // pega quantidade de items da tabela
          let acum = 0
          // Valores que nao podem ser redistribuidos nesta fase: parcelas ja requisitadas
          // e a fatia desta origem nas parcelas mistas (origem 0), que ficam fixas
          let valorFixo = _.sumBy(this.table.items, function (f) {
            if (('' + f.origem) === fase && _.has(f, 'requisitado')) {
              return vm.toNumberSafe(f.valor)
            }
            if (('' + f.origem) === '0') {
              return vm.toNumberSafe(_.get(f, fase === '1' ? 'valor_fbb' : 'valor_parc', 0))
            }
            return 0
          })
          let total = (fase === '1' ? this.totais.projeto.fbb : (fase === '5' ? this.totais.projeto.parceiros : 0)) - valorFixo
          let parcela = Math.ceil(total / quantidade)
          if (quantidade > 0 && total > 0) {
            this.table.items.forEach((item) => { // para cada item recalcula o valor de acordo com a fase
              if (('' + item.origem) === fase && !_.has(item, 'requisitado')) {
                if (acum + parcela > total) {
                  let dif = acum + parcela - total
                  item.valor = parcela - dif
                } else {
                  item.valor = parcela
                }
                acum += item.valor
                // mantem valor_fbb/valor_parc em sincronia com o novo valor
                this.normalizarParcelaSimples(item)
              }
            })
          }
        })
        this.calcularTotais()
        this.$emit('acaoAtualizaSolicitacoes', new Date())
      },
      ehNulo (valor, opcao) {
        return _.isNull(valor) || _.isNaN(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor
      },
      buscaAdiantamentosConcedidos () {
        this.loading = true
        axiosLaravel.get('processos/adiantamento/recursos/' + this.propsProposta.id, {entityId: null}).then((response) => {
          // Traz os adiantamento concedidos do projeto
          this.adiantamentosConcedidos = response.data.adiantamentos_concedidos.row
          this.aplicarAdiantamentosConcedidosEmTableItems()
          this.calcularTotais()
          this.loading = false
          this.$forceUpdate()
        })
          .catch((error) => {
            this.$root.trataErro(error)
          })
      },
      // Aplica requisitado/percentual_comprovado em table.items usando o cache
      // adiantamentosConcedidos. Idempotente; no-op quando o cache ainda não foi
      // populado. Re-aplicado sempre que table.items é recriado (watcher propsParcelas).
      //
      // Parcela mista é UMA linha na tela e DUAS no banco (origem 1 e origem 5), logo
      // dois concedidos — um por recurso. A linha consolidada carrega em `id` apenas o
      // id da origem Fundação; os ids reais das duas origens ficam em id_fbb/id_parc
      // (consolidarGrupoParcelas, mixin parcelasAdiantamento). Casar só por `id` fazia
      // o concedido do Parceiro Estratégico ser descartado, e o Valor Requisitado da
      // mista mostrava apenas a parte da Fundação. Aqui o requisitado é a SOMA dos
      // concedidos das duas origens — é o que atende o Suporte 77853.
      //
      // O Suporte 77853 trata somente do Valor Requisitado: a coluna % Comprov. segue
      // sem consolidação, exibindo o percentual do concedido da própria linha.
      aplicarAdiantamentosConcedidosEmTableItems () {
        if (!this.adiantamentosConcedidos || !this.adiantamentosConcedidos.length) return
        _.forEach(this.table.items, (parcela) => {
          // id pode repetir id_fbb na consolidada; o filtro é sobre os concedidos,
          // então cada concedido entra na soma uma única vez
          const ids = _.compact([_.get(parcela, 'id'), _.get(parcela, 'id_fbb'), _.get(parcela, 'id_parc')])
          if (!ids.length) return
          const concedidos = _.filter(this.adiantamentosConcedidos, (c) => _.includes(ids, c.id_parcela_adiantamento))
          if (!concedidos.length) return
          // Soma em centavos inteiros, mesma convenção do mixin parcelasAdiantamento
          const requisitado = _.reduce(concedidos, (acc, c) => {
            return acc + Math.round(_.toNumber(_.get(c, 'requisitado', 0)) * 100)
          }, 0) / 100
          _.set(parcela, 'requisitado', requisitado)
          // % Comprov. permanece como antes: o percentual do concedido da própria
          // linha, sem consolidação entre as origens
          const concedidoDaLinha = _.findLast(concedidos, (c) => c.id_parcela_adiantamento === parcela.id)
          if (concedidoDaLinha) {
            _.set(parcela, 'percentual_comprovado', concedidoDaLinha.percentual_comprovado)
          }
        })
      },
      verificaFase () {
        this.existeFaseFBB = 0
        this.existeFaseParc = 0
        // Helper consistente com valorProjetoOrigem: aceita adiantavel '1', 1 ou true
        const ehAdiantavel = (it) => ('' + it.adiantavel === '1') || it.adiantavel === true
        if (!_.isUndefined(this.propsAtividades)) {
          this.propsAtividades.forEach((atividade) => {
            if (atividade.itens_orcamentos) {
              atividade.itens_orcamentos.forEach((item) => {
                if (item && ehAdiantavel(item)) {
                  // Aceita origem numérica/string '1'/'5' e código textual (mesma regra de valorProjetoOrigem)
                  if (('' + item.origem) === '1' || item.origem === 'FUNDACAO') {
                    this.existeFaseFBB++
                  }
                  if (('' + item.origem) === '5' || item.origem === 'PARCEIRO_ESTRATEGICO') {
                    this.existeFaseParc++
                  }
                }
              })
            }
          })
        }
        this.$forceUpdate()
      },
      onCancel () {
        this.parcela = {}
        this.showgrid = true
        this.editandoIndex = null
        this.calcularTotais()
      },
      onAdd () {
        // Guard defensivo: origem é obrigatória e precisa ser 0/1/5
        const origemAtual = '' + _.get(this.parcela, 'origem')
        if (!_.includes(['0', '1', '5'], origemAtual)) {
          this.$snotify.error('Selecione uma Origem (Fundação, Parceiro Estratégico ou Parcela Mista) antes de salvar a parcela.')
          return
        }
        // Para Misto, exige valor_fbb e/ou valor_parc maior que zero
        if (origemAtual === '0' && ((+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0)) <= 0) {
          this.$snotify.error('Para Parcela Mista, informe um valor maior que zero em Fundação e/ou Parceiro Estratégico.')
          return
        }
        // Remove erros orfaos de campos do outro branch (single <-> misto) que possam
        // ter ficado registrados antes da troca de origem
        if (origemAtual === '0') {
          this.errors.remove('valor')
          // Trava pelo saldo total: parcelas legadas sem breakdown entram so no total,
          // entao os limites por origem podem superestimar o saldo real do projeto
          const totalParcela = (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0)
          const limiteTotal = Math.max(0, this.limiteParcelaTotal(this.parcela))
          if (this.toCentavos(totalParcela) > this.toCentavos(limiteTotal)) {
            this.$snotify.error('O total da parcela (' + this.$options.filters.real(totalParcela) + ') ultrapassa o saldo total disponível do projeto (' + this.$options.filters.real(limiteTotal) + ').')
            return
          }
        } else {
          this.errors.remove('valor_fbb')
          this.errors.remove('valor_parc')
        }
        this.$validator.validateAll().then((result) => {
          if (result && this.$validator.errors.all().length === 0) {
            // garante valor_fbb / valor_parc / valor coerentes antes de entrar na grade
            this.parcela = this.normalizarParcelaSimples(this.parcela)
            if (_.isNull(this.editandoIndex)) {
              this.table.items.push(this.parcela)
            } else {
              this.table.items.splice(this.editandoIndex, 1, this.parcela)
            }
            this.onCancel()
            this.calcularTotais()
            this.$emit('acaoAtualizaSolicitacoes', new Date())
          } else {
            // Nunca falhar em silencio: mostra o motivo da validacao ter barrado a parcela
            const motivos = this.$validator.errors.all().join(' | ')
            this.$snotify.error(motivos || 'Não foi possível salvar a parcela. Verifique os valores informados.')
          }
        })
      },
      exclui (row) {
        this.table.items.splice(row.index, 1)
        this.parcela = {}
        this.calcularTotais()
        this.$emit('acaoAtualizaSolicitacoes', new Date())
      },
      reincluir (row) {
        this.table.items.push(row.item)
        this.calcularTotais()
        this.$emit('acaoAtualizaSolicitacoes', new Date())
      },
      edita (row) {
        this.verificaFase
        this.editandoIndex = row.index
        this.parcela = Object.assign({}, row.item)
        this.parcelaTabela = row.item
        this.showgrid = false
      },
      moverLinha (linha, direcao) {
        let itens = _.clone(this.table.items)
        let idxOrigem = linha.index
        let idxDestino = (direcao === 'cima' ? -1 : 1) + idxOrigem
        let itemBkp = itens[idxDestino]
        itens[idxDestino] = itens[idxOrigem]
        itens[idxOrigem] = itemBkp
        this.table.items = itens
        this.numerarParcelas()
        this.$forceUpdate()
      },
      // Resíduo só entra como acréscimo quando a parcela atual é a "próxima após a última
      // liberada" (mesma regra do limiteParcela legado). Função auxiliar usada pelos limites
      // por origem.
      ehProximaAposUltimaLiberada (parcela) {
        let ultimaParcelaLiberada = _.last(_.filter(this.table.items, function (p) {
          return p && (_.has(p, 'requisitado') || p.requisitado > 0)
        }))
        if (!ultimaParcelaLiberada) return false
        return (_.has(parcela, 'parcela') && parcela.parcela === ultimaParcelaLiberada.parcela + 1) ||
          (!_.has(parcela, 'parcela') && ultimaParcelaLiberada.parcela === this.table.items.length)
      },
      limiteParcelaFundacao (parcela) {
        // devolução temporária do valor sendo editado, para não bloquear a própria parcela
        let devolveAtual = 0
        if (!_.isNull(this.editandoIndex)) {
          const o = '' + _.get(parcela, 'origem')
          if (o === '0') devolveAtual = +_.get(this.parcelaTabela, 'valor_fbb', 0) || 0
          else if (o === '1') devolveAtual = +_.get(this.parcelaTabela, 'valor', 0) || 0
        }
        let acrescimo = 0
        if (this.totais.residuo.fbb > 0 && this.ehProximaAposUltimaLiberada(parcela)) {
          acrescimo = this.totais.residuo.fbb
        }
        return devolveAtual + this.totais.saldoDisponivel.fbb + acrescimo
      },
      limiteParcelaParceiro (parcela) {
        let devolveAtual = 0
        if (!_.isNull(this.editandoIndex)) {
          const o = '' + _.get(parcela, 'origem')
          if (o === '0') devolveAtual = +_.get(this.parcelaTabela, 'valor_parc', 0) || 0
          else if (o === '5') devolveAtual = +_.get(this.parcelaTabela, 'valor', 0) || 0
        }
        let acrescimo = 0
        if (this.totais.residuo.parceiros > 0 && this.ehProximaAposUltimaLiberada(parcela)) {
          acrescimo = this.totais.residuo.parceiros
        }
        return devolveAtual + this.totais.saldoDisponivel.parceiros + acrescimo
      },
      limiteParcelaTotal (parcela) {
        return this.limiteParcelaFundacao(parcela) + this.limiteParcelaParceiro(parcela)
      },
      // Wrapper retrocompatível: origem 1 -> fundação, 5 -> parceiro, 0 (misto) -> total.
      // Mantido para o input único quando origem !== 0 (template) e callers externos.
      limiteParcela (parcela) {
        const o = '' + _.get(parcela, 'origem')
        if (o === '1') return this.limiteParcelaFundacao(parcela)
        if (o === '5') return this.limiteParcelaParceiro(parcela)
        return this.limiteParcelaTotal(parcela)
      },
      ehParcelaSemOrigem (item) {
        return !_.includes(['0', '1', '5'], '' + _.get(item, 'origem'))
      },
      ehItemNovo (item) {
        return !_.has(item, 'id') || _.includes(_.get(item, 'id', ''), 'novo') || _.find(_.get(this.processoSolicitacao, 'inclusao', []), ['id', item.id])
      },
      ehItemExcluido (item) {
        return _.includes(_.get(this.processoSolicitacao, 'exclusao', []), item.id)
      },
      modificacaoLinha (item, type) {
        if (!item || type !== 'row') return
        if (('' + this.modoVisualizacaoAlteracoes) === 'DETALHADO') {
          if (this.ehItemNovo(item)) return 'modificacaoInclusao'
          if (this.ehItemExcluido(item)) return 'modificacaoExlusao'
        }
      }
    }
  }
</script>

<style scoped>
  .parcelasAdiantamento .botoesUpDown {
    float: right;
    text-align: center;
    color: silver;
  }
  .parcelasAdiantamento .botoesUpDown i:hover {
    cursor: pointer;
    color: steelblue;
  }
</style>


<style>
/* Remove o cabeçalho automático do BootstrapVue (gerado via fields) */
table.tbl-adiantamentos thead > tr[role="row"] {
  display: none !important;
}
table.totais {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin-top: 8px;
}

table.totais td {
  padding: 6px 8px;
  vertical-align: top;
}

table.totais .centralizado {
  text-align: center;
}

table.totais .valor {
  font-weight: 700;
}

/* Ajuste para espelhar a grade principal */
table.totais col.col-parcela {
  width: 8%;
}

table.totais col.col-origem {
  width: 18%;
}

table.totais col.col-fase1 {
  width: 14%;
}

table.totais col.col-fase5 {
  width: 14%;
}

table.totais col.col-valor-adiantavel {
  width: 14%;
}

table.totais col.col-valor-requisitado {
  width: 14%;
}

table.totais col.col-percentual {
  width: 8%;
}

table.totais col.col-acoes {
  width: 10%;
}
</style>


// WEBPACK FOOTER //
// parcela-adiantamento.vue?5f93b3d9